import axios from 'axios';
import BASE_API from '../config/config';

const service = axios.create({
  // process.env.NODE_ENV === 'development' 来判断是否开发环境
  // easy-mock服务挂了，暂时不使用了
  baseURL: 'https://' + BASE_API.BASE_API,
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
});

service.interceptors.request.use(
  config => {
    // if (Cookies.get('token')) {
    //   console.log(Cookies.get('token'))
    //   config.headers['token'] = Cookies.get('token')
    // }
    // console.log(config)
    return config;
  },
  error => {
    console.log(error);
    return Promise.reject();
  }
);

service.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return response.data;
    } else {
      Promise.reject();
    }
  },
  error => {
    console.log(error);
    return Promise.reject();
  }
);

export default service;
